// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as FareEstimateErrorModuleScss from "../styles/FareEstimateError.module.scss";

var styles = FareEstimateErrorModuleScss;

function FareEstimateErrorCmp(Props) {
  var image = Props.image;
  var content = Props.content;
  var button_text = Props.button_text;
  var button_action = Props.button_action;
  var align_text_leftOpt = Props.align_text_left;
  var align_text_left = align_text_leftOpt !== undefined ? align_text_leftOpt : true;
  return React.createElement("div", {
              className: styles["container-error"]
            }, React.createElement("div", {
                  className: styles.content
                }, React.createElement("div", {
                      className: styles.icon
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: image.src,
                          height: image.height,
                          width: image.width,
                          alt: image.alt
                        })), React.createElement("div", {
                      className: align_text_left ? styles["text-wrapper-left"] : styles["text-wrapper"]
                    }, React.createElement("p", {
                          className: styles.title
                        }, content.text), React.createElement("p", {
                          className: styles.subtitle
                        }, content.sub_text)), React.createElement("button", {
                      className: styles["retry-button"],
                      onClick: button_action
                    }, button_text)));
}

var make = FareEstimateErrorCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
